<template>
  <div class="preview-server-body">
    <iframe v-if="fileUrl" :src="fileUrl" style="width: 100%; height: 100%; border: none" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'PreviewServerBody'
})

const props = defineProps({
  panelData: {
    type: Object,
    required: true
  }
})

const fileUrl = computed(() => {
  const url = props.panelData.fileUrl
  return url ? 'https://view.xbongbong.com/view/url?url=' + encodeURIComponent(url) : ''
})
</script>

<style lang="scss" scoped>
.preview-server-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #f5f7fb;
  font-family: 'PingFang SC', sans-serif;
  text-align: center;
}
</style>
